// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"23":"agenda","443":"about","650":"upload"}[chunkId] + "." + {"23":"14c992f8","443":"5b2db0bd","650":"b7c19f2a"}[chunkId] + ".js";
};